import request from '@/utils/request'

export function getAgreementList() {
  return request({ url: '/admin/agreement/list', method: 'post', data: {} })
}

export function getAgreementDetail(data) {
  return request({ url: '/admin/agreement/detail', method: 'post', data })
}

export function updateAgreement(data) {
  return request({ url: '/admin/agreement/update', method: 'post', data })
}
